/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-04-15 10:09:51
 * @LastAuthor: xiaoyao
 * @lastTime: 2020-05-06 11:53:09
 */
const PERMISSION_ENUM = {
  'add': { key: 'add', label: '新增' },
  'delete': { key: 'delete', label: '删除' },
  'edit': { key: 'edit', label: '修改' },
  'query': { key: 'query', label: '查询' },
  'get': { key: 'get', label: '详情' },
  'enable': { key: 'enable', label: '启用' },
  'disable': { key: 'disable', label: '禁用' },
  'import': { key: 'import', label: '导入' },
  'export': { key: 'import', label: '导入' },
}

function plugin(Vue) {

  if (plugin.installed) {
    return
  }

  !Vue.prototype.$auth && Object.defineProperties(Vue.prototype, {
    $auth: {
      get() {
        const _this = this
        return (action) => {
          const perm_list = _this.$store.getters.perm_list
          if (perm_list && perm_list.includes(action)){
            return true
          }
          return false
        }
      }
    }
  })

  !Vue.prototype.$enum && Object.defineProperties(Vue.prototype, {
    $enum: {
      get() {
        // const _this = this;
        return (val) => {
          let result = PERMISSION_ENUM
          val && val.split('.').forEach(v => {
            result = result && result[v] || null
          })
          return result
        }
      }
    }
  })
}

export default plugin


// WEBPACK FOOTER //
// ./src/utils/helper/permission.js